import React, { useState } from "react"

import {
  useRemoveItemFromCart,
  useUpdateItemsFromCart,
  client,
} from "../../state/store"

// SVG
import CancelIcon from "../../svg/exit.svg"

export const LineItem = ({
  id,
  title,
  quantity,
  variant,
  discountAllocations,
  key,
}) => {
  const { selectedOptions, price, image } = variant || {}
  const [stateQuantity, setQuantity] = useState(quantity)

  const updateItemsFromCart = useUpdateItemsFromCart()
  const removeFromCart = useRemoveItemFromCart()

  const updateQuantity = qty => {
    updateItemsFromCart({ id, quantity: qty })
    setQuantity(qty)
  }

  const itemImage = client.image.helpers.imageForSize(image, {
    maxWidth: 100,
    maxHeight: 100,
  })

  return (
    <div className="grid grid-cols-lineItem gap-x-4">
      <div className="row-start-1 self-start col-start-1 col-end-2">
        <img
          src={itemImage}
          alt="Product Thumbnail"
          className="w-full h-auto"
        />
      </div>
      <div className="col-start-2 col-end-3">
        <h2 className="text-sm">{title}</h2>
        {selectedOptions.length && (
          <h2 className="text-sm">
            {selectedOptions.map(option => {
              return <div>{option.value}</div>
            })}
          </h2>
        )}
        <div>
          {discountAllocations.map(
            ({
              allocatedAmount: { amount },
              discountApplication: { title },
            }) => (
              <h2 className="text-sm font-bold">
                {title} (- ${parseFloat(amount).toFixed(2)})
              </h2>
            )
          )}
        </div>
      </div>
      <nav className="col-start-3 justify-self-end row-start-1">
        <button
          onClick={() => removeFromCart(id)}
          className="text-black cursor-pointer"
        >
          <CancelIcon className="stroke-current w-4 text-black" />
        </button>
      </nav>
      <div className="col-start-2 col-end-4 row-start-3 flex justify-between">
        <div className="flex justify-between">
          <button
            onClick={() =>
              stateQuantity === 1 ? null : updateQuantity(stateQuantity - 1)
            }
          >
            -
          </button>
          <input
            type="number"
            value={stateQuantity}
            onChange={e => updateQuantity(parseInt(e.currentTarget.value, 10))}
            name="quantity"
            min="1"
            className="w-8 text-center"
          />
          <button onClick={() => updateQuantity(stateQuantity + 1)}>+</button>
        </div>
        <strong>${parseFloat(price * stateQuantity).toFixed(2)}</strong>
      </div>
    </div>
  )
}
